module.exports = __webpack_public_path__ + "img/4.8655671e.jpg";